import Vue from 'vue'
import Router from 'vue-router'

import ErrorPage from '@/components/ErrorPage'
import Login from '@/components/Login/Login'
import Log from '@/components/Log/Log'
import StockRouter from './stock-router'
import JobRouter from './job-router'
import {isValidSession} from '@/assets/js/common.js'
import AccountingRouter from './accounting-router'
import ReportRouter from   './report-router'
import ControllerRouter from './controller-router'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router)
const commonRoutes = [
  {
    path: '/',
    props: {pageName: 'Admin ใบแจ้งซ่อม'},
    redirect: '/job/J01'
  },
  {
    path: '/error',
    name: 'error',
    component: ErrorPage
  },
  {
    path: '/log',
    name: 'log',
    component: Log
  },
  {
    path: '/bpcLogin',
    name: 'bpcLogin',
    component: Login
  },
]
const routes = commonRoutes.concat(StockRouter, AccountingRouter, JobRouter,ReportRouter,ControllerRouter);
let router = new Router({routes: routes});

router.beforeEach((to, from, next) => {
  if (from.name != null && 
      (from.name == 'create-job' || from.name == 'edit-job') ||  from.name == 'create-bpe') {
    if (!confirm('ต้องการออกจากหน้าจอ บันทึก / แก้ไขใบแจ้งซ่อม ใช่หรือไม่')) {
      return;
    }
  }
  if (to.name !== 'bpcLogin') {
    isValidSession() ? next() : next('/bpcLogin');
  } else {
    next();
  }
});

export default router
